import type { AvailableLanguagesType } from '@carrefour-gcs/shared';
import type { Locale } from 'date-fns';
import { enUS, es, fr } from 'date-fns/locale';

export const LANGUAGE_LOCAL_MAP: Record<AvailableLanguagesType, Locale> = {
  en: enUS,
  'fr-FR': fr,
  'fr-BE': fr,
  es
};
